import { Component, OnInit, Output, Input, EventEmitter, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { GlobalService } from '../services/global.service';
import { CompressImage } from './CompressImage';

@Component({
    selector: 'app-image-uploader',
    templateUrl: './image-uploader.component.html',
    styleUrls: ['./image-uploader.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImageUploaderComponent implements OnInit {
	@Input() allowed_extensions: Array<string> = [];
	@Input() multiple: boolean = false;
	@Input() quantity: number = 8;
	@Input() cover: boolean = false;
	@Input() prefix_name;
	@Input() quality_compression: number = 1024;
	@Input() locations: boolean;
	@Input() useCheckbox: boolean;
	@Input() checkboxText: string = "";
	@Input() allowSendMultiple?: boolean = false; //Permite enviar varias imagenes automaticamente sin necesidad de hacer "continue"
	@Input() height?: string; //Permite enviar varias imagenes automaticamente sin necesidad de hacer "continue"
	@Output() fileListSend: EventEmitter<File[]> = new EventEmitter();
	@Output() checkBoxList: EventEmitter<any[]> = new EventEmitter();
	accepted: string;
	_fileList: any = [];
	imgList: any = [];
	linkList: any = [];
	invalidFiles: any = [];
	covers: any = [];
	checkboxes: any = [];


	constructor(public _gS: GlobalService) { }

	ngOnInit() {
		if (this.cover) {
			this.covers = [true]

		}
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.allowed_extensions) {
			this.accepted = this.allowed_extensions.map(a => a = `.${a}`).join(',');
		}
	}


	onChangeHandler(fileInput: any) {
		var files = fileInput.target.files;
		for (var file of files) {
			var ext = file.name.split('.')[file.name.split('.').length - 1];
			if (this.allowed_extensions.lastIndexOf(ext) != -1) {
				if (this.multiple) {
					this._fileList.push(file)
				} else {
					this._fileList = [file];
				}

				Promise.all(Array.prototype.slice.call(this._fileList, 0).map(this.readFileAsImage, this))
					.then(data => this.imgList = data);

				if (!this.multiple || this.allowSendMultiple) {
					this.onSendFiles(this.imgList)
				}

			} else {
				this.invalidFiles.push(file);
			}
		}
	}
	onDropHandler(fileList: Array<File>) {
		var files = fileList;
		for (var file of files) {
			var ext = file.name.split('.')[file.name.split('.').length - 1];
			if (this.allowed_extensions.lastIndexOf(ext) != -1) {


				if (this.multiple) {
					this._fileList.push(file)
				} else {
					this._fileList = [file];
				}

				Promise.all(Array.prototype.slice.call(this._fileList, 0).map(this.readFileAsImage, this))
					.then(data => this.imgList = data);

				if (!this.multiple || this.allowSendMultiple) {
					this.onSendFiles(this.imgList)
				}

			} else {
				console.log('Archivos invalidos')
				this.invalidFiles.push(file);
			}
		}


		Promise.all(Array.prototype.slice.call(this._fileList).map(this.readFileAsImage, this))
			.then(data => this.imgList = data);
	}

	onInvalidDropHandler(fileList: Array<File>) {
		this.invalidFiles = fileList;
	}

	onSendFiles(event) {
		Promise.all(Array.prototype.slice.call(this._fileList).map(this.readFileAsObject, this))
			.then(data => {
				var files: any = data;
				if (this.cover) {
					var pos = 0;
					for (let file of files) {
						file.cover = false;
						if (this.covers[pos]) {
							file.cover = true;
						}
						pos++
					}
				}
				// console.log("Aqui se envian los archvios por emitter a la vista padre, ya van compresas", files)
				this.fileListSend.emit(files)
				this.checkBoxList.emit(this.checkboxes);
			});
	}
	Resize(ev) {
		//console.log(ev.path[0].naturalWidth)

	}
	coverSelected() {
		if (this.cover) {
			for (let cov of this.covers) {
				if (cov) {
					return true
				}

			}
			return false
		}
		return true


	}
	checkCover(pos) {
		var newpos = 0
		if (this.covers[pos]) {
			for (let cov of this.covers) {
				this.covers[newpos] = false
				newpos++;
			}
			this.covers[pos] = true
		}
	}
	onDeleteFile($event, key) {
		if (key > -1) {
			this._fileList.splice(key, 1);
			this.imgList.splice(key, 1);
			if (this.useCheckbox) {
				this.checkboxes.splice(key, 1);
			}
		}

		if (this.allowSendMultiple) {
			this.onSendFiles(this.imgList)
		}
	}

	readFileAsImage(file: File) {
		var compress = new CompressImage(file, this.quality_compression, this.prefix_name);

		return new Promise((resolve, reject) => {
			compress.getImage().then(f => {
				var reader = new FileReader();
				reader.onloadend = (e) => {
					resolve(reader.result)
				};
				reader.onerror = e => reject(e);
				reader.readAsDataURL(<Blob>f);
			});
		});
	}

	readFileAsObject(file: File) {
		var compress = new CompressImage(file, this.quality_compression, this.prefix_name);
		return new Promise((resolve, reject) => {
			compress.getImage().then(f => {
				var reader = new FileReader();
				reader.onloadend = (e) => {
					f['url_data'] = reader.result;
					resolve(f)
				};
				reader.onerror = e => reject(e);
				reader.readAsDataURL(<Blob>f);
			});
		});
	}

}
